import { render, staticRenderFns } from "./TimelinePage.vue?vue&type=template&id=fa12aa1a&scoped=true"
import script from "./TimelinePage.vue?vue&type=script&lang=ts"
export * from "./TimelinePage.vue?vue&type=script&lang=ts"
import style0 from "./TimelinePage.vue?vue&type=style&index=0&id=fa12aa1a&prod&lang=scss&scoped=true"
import style1 from "./TimelinePage.vue?vue&type=style&index=1&id=fa12aa1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa12aa1a",
  null
  
)

export default component.exports